/** VUEX module for contract management */
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    // initial state
    entities: {},
    list: [],
    currentSubject: null,
  },
  getters: {
    // getters
    /**
     * Return array of resources.
     */
    list: state => {
      return state.list.map(id => state.entities[id.toString()]);
    },
    /**
     * Get resource by id.
     */
    byId: state => {
      return id => state.entities[id.toString()];
    },
    /**
     * Get current subject.
     */
    currentSubject: state => {
      return state.currentSubject;
    },
  },
  mutations: {
    // mutations
    SET_CURRENT_SUBJECT: (state, subject) => {
      state.currentSubject = { ...subject };
    },
    FETCH_LIST_SUCCESS: (state, response) => {
      const { data } = response;

      data.forEach(m => {
        Vue.set(state.entities, m.id.toString(), m);
      });

      state.list = data.map(m => m.id.toString());
    },
    FETCH_LIST_ERROR: state => {
      state.list = [];
    },
    FETCH_SINGLE_SUCCESS: (state, response) => {
      const { data } = response;
      const id = data[id].toString();

      Vue.set(state.entities, id, data);
    },
  },
  actions: {
    // actions
    FETCH_LIST: ({ commit, state }, payload) => {
      state.list = [];
      commit('app/START_PROCESSING', null, { root: true });
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$httpMain({
            url: `subjects?grade_id=${payload.grade_id}`,
            method: 'GET',
          })
          .then(response => {
            resolve(response);
            commit('FETCH_LIST_SUCCESS', response);
          })
          .catch(err => {
            reject(err);
            commit('FETCH_LIST_ERROR', err);
          })
          .finally(() => {
            commit('app/STOP_PROCESSING', null, { root: true });
          });
      });
    },
    FETCH_SINGLE: ({ commit }, id) => {
      commit('START_PROCESSING', null, { root: true });
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$httpMain({ url: `subjects/${id}`, method: 'GET' })
          .then(response => {
            resolve(response);
            commit('SET_CURRENT_SUBJECT', response.data);
            commit('FETCH_SINGLE_SUCCESS', response);
          })
          .catch(err => {
            reject(err.response);
          })
          .finally(() => {
            commit('STOP_PROCESSING', null, { root: true });
          });
      });
    },
  },
};
